import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';
import { type TFunction } from 'i18next';

import { DurationParts, getDurationParts } from './get-duration-parts';

dayjs.extend(durationPlugin);

export const formatDuration = (
  value: number,
  t: TFunction,
  {
    withUnit,
    unit = DurationParts.seconds,
  }: {
    withUnit?: boolean;
    unit?: DurationParts;
  } = {}
) => {
  const parts = getDurationParts(value, unit);

  const res: string[] = [];

  for (let index = parts.length - 1; index >= 0; index--) {
    const [part, partValue] = parts[index];

    if (partValue) {
      const formattedValue = withUnit
        ? t(`duration.${part}`, { count: partValue })
        : partValue.toString();

      res.unshift(formattedValue);
    }
  }

  if (!res.length) return '0s';

  return res.join(' ');
};
